import React from 'react';
import { ReactComponent as LogoSvg } from '../assets/logo.svg';

const BrandSpinner = ({ size = 48, className = '' }) => {
  const dimension = typeof size === 'number' ? `${size}px` : size;

  return (
    <div
      className={`inline-flex items-center justify-center ${className}`}
      style={{ width: dimension, height: dimension }}
      aria-label="Loading PanelGear"
      role="status"
    >
      <LogoSvg
        className="h-full w-full animate-spin"
        style={{ color: 'hsl(var(--foreground))', fill: 'currentColor' }}
        aria-hidden
      />
    </div>
  );
};

export default BrandSpinner;
